export default "__VITE_ASSET__1a77cd59__"